import { useI18n } from 'vue-i18n'
import { NumberFormat } from '@/i18n/i18n'

export function useFormatValue() {
  const { n } = useI18n()

  const formatValue = (
    val: string | number | null | undefined,
    formatType: NumberFormat = NumberFormat.DECIMAL,
    emptyPlaceholder = '–'
  ): string => {
    if (val === null || val === undefined || val === '') {
      return emptyPlaceholder
    }

    let num = Number(val)

    if (isNaN(num) && typeof val === 'string' && val.includes(',')) {
      num = Number(val.replace(',', '.'))
    }

    if (!isNaN(num)) {
      return n(num, formatType)
    }

    return val.toString()
  }

  return {
    formatValue
  }
}
